<div class="flex gap-2.5 items-center">
  <div [appTooltip]="removeTooltip()">
    <div
      [ngClass]="{
        disabled: disabledRemove(),
      }"
      [attr.disabled]="disabledRemove() ? true : null"
      (click)="deleteItem()"
      class="remove-btn icon-minus-box"
    ></div>
  </div>
  <div [appTooltip]="addTooltip()">
    <div
      [ngClass]="{
        disabled: disabledAdd(),
      }"
      [attr.disabled]="disabledAdd() ? true : null"
      (click)="insertItem()"
      class="add-btn icon-plus-box"
    ></div>
  </div>
</div>
